import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-4 flex items-center bg-blue-50 border-l-4 border-blue-400 p-4 rounded" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "flex flex-col gap-2 w-full bg-white rounded-lg p-4 shadow" }
const _hoisted_4 = { class: "flex flex-wrap gap-3 items-center" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InviteByLinkSection = _resolveComponent("InviteByLinkSection")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", {
        innerHTML: _ctx.INFO_ICON,
        class: "w-6 h-6 text-blue-400 flex-shrink-0"
      }, null, 8, _hoisted_2),
      _cache[0] || (_cache[0] = _createElementVNode("span", { class: "ml-3 text-base text-gray-700 leading-normal" }, " To invite expert via your own software like CRM or marketing automation platforms you can copy and paste this link anywhere. The icons/buttons below will open up these software login pages to make it easier for you. You have the option to decide if you want the signup link to go to your customized program landing page first or directly to the profile signup form. After you send the invites you can check the expert status in the Experts tab. ", -1))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_InviteByLinkSection, {
        invitationType: "experts",
        directSignup: _ctx.directSignup,
        showInstructions: false,
        class: "mb-2"
      }, null, 8, ["directSignup"]),
      _cache[1] || (_cache[1] = _createElementVNode("span", { class: "font-medium text-sm mb-2" }, " OR Use Your Software to Invite Experts ", -1)),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.softwareList, (software) => {
          return (_openBlock(), _createElementBlock("button", {
            key: software.id,
            class: "p-2 bg-gray-100 rounded hover:bg-primary-purple hover:text-white transition",
            onClick: ($event: any) => (_ctx.$emit('software-click', software))
          }, [
            _createElementVNode("img", {
              src: software.icon,
              alt: software.name,
              class: "w-8 h-8"
            }, null, 8, _hoisted_6)
          ], 8, _hoisted_5))
        }), 128))
      ])
    ])
  ], 64))
}